<template>
  <div>
    <!-- 产品列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>组合子产品</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <el-row class="conentRow">
        <div>
          
          </div>
        <div>
          <el-col class="conentBtn" style="width:auto;" >
            <el-button type="primary" @click="addTao" >添加子产品</el-button>
          </el-col>
      </div>
      </el-row>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
      <el-table-column prop="id" label="产品ID" ></el-table-column>

        <el-table-column prop="product_son_name" label="产品名称" ></el-table-column>
        <el-table-column prop="typename" label="产品分类" ></el-table-column>

        <!-- <el-table-column prop="product_son_name" label="产品价格" ></el-table-column>
        <el-table-column prop="product_son_name" label="产品分类" ></el-table-column>
        <el-table-column prop="product_son_name" label="状态" ></el-table-column>
        <el-table-column  label="操作" >
          <template>
              <div class="caozuo">
                <div class="deteleSpan">删除</div>
                <div class="detatilSpan">详情</div>
              </div>
          </template>
        </el-table-column> -->
      </el-table>
    </el-card>
    <el-dialog :close-on-click-modal="false"
        title="添加套票"
        :visible.sync="addProDialogVisible"
        :before-close="addProHandleClose"
        width="49rem"
        center
      >
        <div class="content">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- <el-form-item label="产品分类：">
              <el-select  placeholder="请选择分类" clearable>
                <el-option
                  v-for="item in option"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="产品名称：">
              <el-input v-model="productSonName" placeholder="请输入名字"></el-input>
            </el-form-item>
            <el-form-item label="产品分类：">
              <el-select v-model="productSonType"  placeholder="请选择产品分类">
                <el-option
                    v-for="item in productop"
                    :key="item.id"
                    :label="item.typename"
                    :value="item.id"
                  ></el-option>
              </el-select>
              <!-- <el-input v-model="" placeholder="请输入产品分类"></el-input> -->
            </el-form-item>
            <!-- <el-form-item label="产品价格：">
              <el-input v-model="productSonName" placeholder="请输入数字"></el-input>
            </el-form-item> -->
          </el-form> 
           <div class="contentBtns">
            <!-- <div>重置</div> -->
            <div @click="btns">确认保存</div>
           </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { getProductSonList , addProductSon , ScenicProductSonType } from '@/request/scenic.js'
import { Message } from 'element-ui';
export default {
  data() {
    return {
      addProDialogVisible:false,
      tableData: [
      ],
      multipleSelection:[],
      data:{
        token:window.sessionStorage.getItem('Token'),
      },
      productSonName:'',
      productSonType:'',
      ruleForm:{},
      option:[],
      productop:[]
    };
  },
  created(){
    ScenicProductSonType(this.data).then(res=>{
      if(res.data.rcode==200){
        this.productop = res.data.result
      }
    })
    this.getList()
  },
  methods: {
    chaxun(){
      
    },
    addTao(){
      this.productSonName = ''
      this.productSonType = ''
      this.addProDialogVisible = true
    },
    addProHandleClose(){
      this.addProDialogVisible = false
      this.productSonName = ''
      this.productSonType = ''
    },
    btns(){
      if(this.productSonName==''){
        Message.error('请输入套票名称')
        return false
      }
      if(this.productSonType==''){
        Message.error('请输入产品分类')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        productSonName:this.productSonName,
        productSonType:this.productSonType
      }
      addProductSon(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('添加套票成功')
          this.getList()
          this.addProDialogVisible = false
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 获取产品列表数据
    getList(){
      getProductSonList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result
        }
      })
    },
    // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
   // 全选
   handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-card__body {
  padding: 0 20px;
}
.conentBox {
  margin-top: 17px;
  padding: 2rem;
  .conentRow {
    margin: 0 0 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      .conentBtn {
        margin-bottom: 10px;
        margin-left: 1rem;
        // width: 120px;
        .el-button {
          width: 100px;
          // width: 84%;
          background: #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
::v-deep .el-popover__reference{
  color: #FF4D4F;
  margin-right: 1.9rem;
  cursor: pointer;
}

.conentRow /deep/ .el-button{
  color: #fff;
  background: #246deb;
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
.totla{
  position: absolute;
  left: 2rem;
  width: 35rem;
  color: red !important;
}
.detele_btns{
  border-radius: 0.4rem;
  margin: 0 2rem;
  width: 9.2rem;
  height: 3.8rem;
  border: 1px solid #FF4D4F;
  color: #FF4D4F;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  cursor: pointer;
}
.contentBtns{
    margin-top: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 10rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
     
        background: #246DEB;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 2rem 0 !important;
    border-top: 1px solid #e5e5ea;
  }
  .content{
    padding: 0 2rem;
    box-sizing: border-box;
    ::v-deep .el-select{
      width: 100%;
    }
  }
  .conentCol {
        width: 24rem !important;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        /deep/.el-input {
          width: 24rem !important;
        }
        /deep/.el-select{
          width: 24rem !important;
        }
      }
      .deteleSpan{
        color: #FF4D4F;
      }
      .detatilSpan{
        color: #246DEB;
        margin-left: 2rem;
      }
      .caozuo{
        display: flex;
        align-items: center;
      }
</style>